import {
    createRoot
} from "react-dom/client";
import App from "../src/index";

const originalWarn = console.warn;
console.warn = (...args) => {
    if (typeof args[0] === "string" && (
        args[0].includes("pointerEvents") ||
        args[0].includes("useNativeDriver") ||
        args[0].includes("TouchableWithoutFeedback") ||
        args[0].includes("Cannot record touch")
    )) return;
    originalWarn(...args);
};

const root = createRoot(document.getElementById("app-root")!);
root.render(<App />);
